"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _immutable = require("immutable");
var _StateHelper = _interopRequireDefault(require("../helpers/StateHelper.js"));
var _User = _interopRequireDefault(require("../factories/User.js"));
var _constants = require("../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var stateHelper = new _StateHelper.default(_User.default);
var initialState = stateHelper.initialState;
exports.initialState = initialState;
var reducers = {};
reducers[_constants.USER_UPDATED] = stateHelper.set;

// Non-Users Action Reducers

reducers[_constants.SESSION_FETCHED] = stateHelper.set;
reducers[_constants.SESSION_RESET] = stateHelper.reset;
reducers[_constants.QUESTION_MARKED] = stateHelper.set;
reducers[_constants.QUESTION_UNMARKED] = stateHelper.set;
reducers[_constants.PEARL_MARKED] = stateHelper.set;
reducers[_constants.PEARL_UNMARKED] = stateHelper.set;
reducers[_constants.QUIZ_FETCHED_PERFORMANCE] = stateHelper.set;
reducers[_constants.QUIZ_FETCHED_TAKE] = stateHelper.set;
reducers[_constants.QUIZZES_FETCHED] = stateHelper.set;
reducers[_constants.ORGANIZATION_MEMBERS_FETCHED] = stateHelper.set;
reducers[_constants.MEMBER_GROUPS_FETCHED] = stateHelper.set;
reducers[_constants.MEMBER_GROUP_FETCHED] = stateHelper.set;
reducers[_constants.MEMBER_GROUP_USERS_FETCHED] = stateHelper.set;
reducers[_constants.ASSIGNMENTS_LIST_FETCHED] = stateHelper.set;
reducers[_constants.ORGANIZATION_UNLOAD_MEMBERS] = stateHelper.reset;
reducers[_constants.EXAM_TEMPLATES_LIST_FETCHED] = stateHelper.set;
reducers[_constants.REPORT_USERS_FETCHED] = stateHelper.set;
reducers[_constants.RELOAD_CURRENT_USER] = function reloadCurrentUser(state, payload) {
  return state.set(payload.get('id'), payload);
};
reducers[_constants.ORGANIZATION_SELECTED] = function (state, payload) {
  return state.filter(function (user) {
    return payload.whitelistedUserIds.includes(user.get('id'));
  });
};
reducers[_constants.ASSIGNMENT_USERS_FETCHED] = stateHelper.set;
reducers[_constants.ASSIGNMENT_FETCHED] = stateHelper.set;
reducers[_constants.PERFORMANCE_QUIZZES_FETCHED] = function performanceQuizzesFetched(state, payload) {
  if (!payload.assignment_creators) return state;
  return state.withMutations(function (newState) {
    payload.assignment_creators.forEach(function (user) {
      newState.set(user[0], state.get(user[0], new _immutable.Map()).merge({
        id: user[0],
        first_name: user[1],
        last_name: user[2]
      }));
    });
  });
};
reducers[_constants.QUESTION_BANK_SELECTED] = function questionBankSelected(state, payload) {
  if (!payload.meta || !payload.meta.user) return state;

  // TODO: In API V2 this will be updated so we can just use stateHelper.set regularly
  return stateHelper.set(state, {
    data: payload.meta.user
  });
};
var _default = exports.default = stateHelper.createReducer(reducers);